import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Modal, ModalProps, notification, Typography } from 'antd';

import { useBrandsSlice, useJoinOfferMutation } from 'entities/Brand';
import { useSetRejectedMutation } from 'entities/Notification';
import { JoinForm } from 'shared/ui';

interface IJoinInviteOfferProps extends ModalProps {}

export const JoinInviteOffer: FC<IJoinInviteOfferProps> = ({ ...props }) => {
	const { t } = useTranslation();
	const { joinedInviteOffer, setJoinedInviteOffer } = useBrandsSlice();
	const [joinOffer, { status, isLoading }] = useJoinOfferMutation();
	const [setRejected] = useSetRejectedMutation();

	useEffect(() => {
		if (status === 'fulfilled') {
			setRejected({ ids: [joinedInviteOffer?.notificationId || 0], delete_invite: false });
			setJoinedInviteOffer(null);
			notification.open({
				message: t('Заявка отправлена успешно'),
				description: t('Ваши площадки будут подключены к офферу'),
				type: 'success',
				placement: 'topRight',
				showProgress: true,
				pauseOnHover: true,
			});
		}
	}, [status]); // eslint-disable-line

	if (!joinedInviteOffer?.brand || !joinedInviteOffer?.offer) return null;

	const { brand, offer, source } = joinedInviteOffer;

	return (
		<Modal
			{...props}
			width={450}
			open={!!joinedInviteOffer}
			onCancel={() => setJoinedInviteOffer(null)}
			centered
			footer={null}>
			<Flex vertical gap={24}>
				<Typography.Title level={4} style={{ margin: 0 }}>
					{t('Подключение к офферу')}
				</Typography.Title>

				<JoinForm
					type="offer"
					isInvite
					brand={brand}
					offer={offer}
					source={source}
					isLoading={isLoading}
					sourceOptions={[{ label: source.name, value: source.uuid }]}
					onJoin={joinOffer}
					onClose={() => setJoinedInviteOffer(null)}
				/>
			</Flex>
		</Modal>
	);
};
